module.exports = __webpack_public_path__ + "static/img/404.de7853f7.png";